import React, {VoidFunctionComponent} from 'react';

import styles from './loading-bar.module.css';

const LoadingBar: VoidFunctionComponent<Record<string, unknown>> = () => (
  <div className={styles.loadingBar} />
);

export default LoadingBar;
